import { createContext, ReactNode } from 'react';

export type LayoutEntityUpdateAlertValues = {
  alert: ReactNode;
};

const LayoutEntityUpdateAlertContext = createContext<LayoutEntityUpdateAlertValues>({
  alert: null,
});

export default LayoutEntityUpdateAlertContext;
